import React from "react";
import style from '../../Assets/css/Preloader.module.css';

const Preloader = () => {
  return (
    <div className={style.preloader}>
      <div className={style.loader}></div>
    </div>
  );
};

export default Preloader;
